import { SuretyAccountPreview } from "@portal/api/account/agent";
import { useAdminFetchAgencyPreviews } from "@portal/api/agency/admin";
import { useFetchAccountPreviews } from "@portal/api/previews";
import { DynamicDataTable } from "@portal/components/ui/DynamicDataTable/DynamicDataTable";
import { useCallback } from "react";
import type { PreviewTableProps } from "../../shared/layouts/EntityPreviewsLayout";
import { useAdminPreviewsTable } from "../shared/useAdminPreviewsTable";
import { adminAccountsTableColumns } from "./columns";

const getRowHref = (row: SuretyAccountPreview) => `/accounts/${row.id}`;

type AccountSubmissionFilter = (account: SuretyAccountPreview) => boolean;

export const createAdminAccountSubmissionPreviews = (
	tableName: string,
	filterPredicate: AccountSubmissionFilter,
) => {
	const AdminAccountSubmissionPreviews = ({ scope }: Pick<PreviewTableProps, "scope">) => {
		const { accountPreviews } = useFetchAccountPreviews();
		const { agencyNameMap } = useAdminFetchAgencyPreviews();

		const enrichRow = useCallback(
			(account: SuretyAccountPreview, underwriterName: string) => ({
				...account,
				underwriterName,
				agencyName: agencyNameMap[account.agencyId] ?? "N/A",
			}),
			[agencyNameMap],
		);
		const { data, defaultColumnFilters, scopeColumnFilters } = useAdminPreviewsTable({
			data: accountPreviews,
			filterPredicate,
			enrichRow,
			scope,
		});

		return (
			<DynamicDataTable
				name={tableName}
				columns={adminAccountsTableColumns}
				getRowHref={getRowHref}
				data={data}
				defaultColumnFilters={defaultColumnFilters}
				enforcedColumnFilters={scopeColumnFilters}
				loadingMessage="Loading accounts..."
				enableExportToCSV
			/>
		);
	};

	return AdminAccountSubmissionPreviews;
};
